import {Routes} from '@angular/router';
import {authGuard} from '../../guards/auth-guard/auth-guard';
import {rootAdminGuard} from '../../guards/root-admin-guard/root-admin-guard';

export const customerRoutes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    loadComponent: () =>
      import('./dashboard/customer-dashboard.page').then(m => m.CustomerDashboardPage),
    canActivate: [authGuard, rootAdminGuard],
  },
  {
    path: 'create',
    loadComponent: () =>
      import('./create/customer-create.page').then(m => m.CustomerCreatePage),
    canActivate: [authGuard, rootAdminGuard],
  },
  {
    path: 'detail/:id',
    loadComponent: () =>
      import('./detail/customer-detail.page').then(m => m.CustomerDetailPage),
    canActivate: [authGuard, rootAdminGuard],
  },
  {
    path: 'edit/:id',
    loadComponent: () =>
      import('./edit/customer-edit.page').then(m => m.CustomerEditPage),
    canActivate: [authGuard, rootAdminGuard],
  },
];
